/**
 * A helper function used in form validation to extract value from a form control
 * The value can either be a string or an object with a key that matches the bindValue value
 *
 * @param object an object which is either a string or object with some properties
 * @param autoCompleteKey optional key property for which to get the value of object from
 */
export const extractStringValue = (
  // eslint-disable-next-line @typescript-eslint/ban-types
  object: string | object,
  autoCompleteKey?: string,
): string => (autoCompleteKey && typeof object === 'object' ? object[autoCompleteKey] : object);

export const splitString = (value: string, splitBy: string = ','): string[] | null => {
  return value ? value.replace(/ /g, '').split(splitBy) : null;
};